export default "__VITE_ASSET__5b52e49b__"